import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateFunction } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateFunction() {
  return useMutation({
    mutationFn: async ({ item, functionId }) => {
      const payload = buildPayload(item);
      const response = await updateFunction({ item: payload, functionId });
      return response;
    },
    onSuccess: () => {
      toast.success("Function Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
